module.exports = __webpack_public_path__ + "img/cover.dbae4c18.webp";